interface BulletDesc {
	bulletTex: PIXI.Texture;
	speed?: number;
}

class Bullet extends PIXI.Sprite {

	desc: BulletDesc;

	constructor(desc: BulletDesc) {
		super(desc.bulletTex);
		this.anchor.set(0.5);
		this.desc = desc;
		// this.blendMode = PIXI.BLEND_MODES.ADD;
	}

	targetPos: PIXI.Point;
	targetMob: Bunny;
	targetMobLife: number;
	speed: number = 50;
	zombie: boolean = false;
	shooter: Building;

	targetVel: PIXI.Point;

	public updateMove(delta: number) {

		if (this.targetMob) {
			if (this.targetMob.zombie ||
				this.targetMob.dead ||
				this.targetMob.lifeNumber !== this.targetMobLife) {
				this.targetMob = null;
			} else {
				this.targetPos = this.targetMob.position;
				this.targetVel = null;
			}
		}

		if (!this.targetPos || this.zombie) {
			return;
		}

		const pos = this.position;
		const tg = this.targetPos;

		if (!this.targetVel) {
			const tv = new PIXI.Point();
			tv.set(tg.x - pos.x,
				tg.y - pos.y);
			const d = 1.0 / Math.sqrt(tv.x * tv.x + tv.y * tv.y);
			tv.x *= d;
			tv.y *= d;
			this.rotation = Math.atan2(-tv.y, -tv.x);
			this.targetVel = tv;
		}

		const tv = this.targetVel;
		const dist = this.speed * delta;
		pos.x += tv.x * dist;
		pos.y += tv.y * dist;

		if ((tg.x - pos.x) * tv.x + (tg.y - pos.y) * tv.y < 0.1) {
			//kill me
			this.zombie = true;
			this.visible = false;
		}
	}
}
